import client from './api-client';


const getUser = () => {
    return JSON.parse(localStorage.getItem("user"));
}

const getLocalRefreshToken = () => {
    const user = getUser();
    return user?.token?.refreshToken;
}

const getLocalAccessToken = () => {
    const user = getUser();
    return user?.token?.accessToken;
}

const updateLocalAccessToken = (token) => {
    let user = getUser();
    user.token.accessToken = token;
    localStorage.setItem("user", JSON.stringify(user));
}
const redirect=()=>{
    alert('Su sesión ha expirado. Para continuar ingrese nuevamente.')
    localStorage.removeItem("user");
    window.location.href = '/login'

}

const interceptor = () => {
   
    client.instance.interceptors.request.use(
        (res) => {
            const token = getLocalAccessToken();
           
            if (token) {
                res.headers["Authorization"] = token;
            }else{
                window.location.href = '/login'
                
            }
            return res;
        },
        (error) => {
            return Promise.reject(error);
        }
    );

    client.instance.interceptors.response.use(
        (res) => {
            return res;
        },
        async (err) => {

            const originalConfig = err.config;
            console.log("err: ", err)
            console.log('err.response', err.response);
           
            if (err.response) {

                // Access Token was expired
                if (err.response.status === 401 && !originalConfig._retry) {
                   
                    originalConfig._retry = true;
                    
                    try {
                        
                        let body = btoa(JSON.stringify({
                            "user": getUser().userName,
                            "refreshToken": getLocalRefreshToken()
                        }));                        
                        
                        const rs = await client.post('refreshtoken', body);                        
                        //console.log('rs.data', rs.data.object);

                        const { accessToken } = rs.data.object;
                        updateLocalAccessToken(accessToken);
                        
                        return client.instance(originalConfig);

                    } catch (_error) {
                        localStorage.removeItem("user");
                        window.location.href = '/login'
                        return Promise.reject(_error);
                    }
                }
            }
           
            redirect()
            return Promise.reject(err);
        }
    );
};

export default interceptor;